import { BehaviorSubject, Observable, Subscription, shareReplay } from 'rxjs';
import { Injectable, inject } from '@angular/core';

import { Ciclo } from '@app/shared/models/ciclo';
import { FiltroResultadoAvaliacao } from '../../models/filtro-resultado-avaliacao';
import { FormGroup } from '@angular/forms';
import { Orgao } from '@app/shared/models/orgao';
import { ProcessoAvaliativo } from '@app/shared/models/processo-avaliativo';
import { ResultadoAvaliacaoApiService } from '../../services/resultado-avaliacao-api.service';
import { ResultadoAvaliacaoPaginado } from '../../models/resultado-avaliacao';

@Injectable({
	providedIn: 'any'
})
export class ResultadoAvaliacaoInstitucionalService {
	filtro = new FiltroResultadoAvaliacao();
	subscriptions: Subscription | undefined = undefined;
	resultado$ = new BehaviorSubject<ResultadoAvaliacaoPaginado | undefined>(undefined);
	orgaos$?: Observable<Orgao[]>;
	processosAvaliativos$?: Observable<ProcessoAvaliativo[]>;
	ciclos$?: Observable<Ciclo[]>;

	resultadoAvaliacaoApi = inject(ResultadoAvaliacaoApiService);

	listarOrgaos() {
		this.orgaos$ = this.resultadoAvaliacaoApi.listarOrgaos().pipe(shareReplay(1));
	}

	listarProcessosAvaliativos(idOrgao: number) {
		this.processosAvaliativos$ = this.resultadoAvaliacaoApi.listarProcessosAvaliativos(idOrgao).pipe(shareReplay(1));
	}

	listarCiclos(idOrgao: number, idProcessoAvaliativo: number) {
		this.ciclos$ = this.resultadoAvaliacaoApi.listarCiclos(idOrgao, idProcessoAvaliativo).pipe(shareReplay(1));
	}

	pesquisarAlcance() {
		this.subscriptions = this.resultadoAvaliacaoApi
			.consultarResultadoAvaliacaoInstitucional(this.filtro)
			.pipe(shareReplay(1))
			.subscribe((avaliacao: ResultadoAvaliacaoPaginado) => {
				this.resultado$.next(avaliacao);
			});
	}

	converterFormularioParaFiltro(form: FormGroup) {
		const filtro = new FiltroResultadoAvaliacao();
		filtro.idOrgao = form.get('orgao')?.value?.codigo;
		filtro.idProcessoAvaliativo = form.get('processoAvaliativo')?.value?.id;
		filtro.idCiclo = form.get('ciclo')?.value?.id;
		this.filtro = filtro;
	}

	limpar() {
		this.filtro = new FiltroResultadoAvaliacao();
		this.limparResultado();
		this.processosAvaliativos$ = undefined;
		this.ciclos$ = undefined;
	}

	limparResultado() {
		this.resultado$ = new BehaviorSubject<ResultadoAvaliacaoPaginado | undefined>(undefined);
	}

	salvarAlcance(alcance: number, idAvaliacao: number): Observable<any> {
		return this.resultadoAvaliacaoApi.salvarAlcance(alcance, idAvaliacao);
	}
}
